import { InviteProfessional } from '~/commonComponents/InviteProfessional';
import { IDashboardJob } from '~/domain/DashboardJobs/';
import { RedirectButton } from '../../../../../commonComponents/Table/RedirectButton';
import { TableData } from '../../../../../commonComponents/Table/TableData';
import { UserSubProfession } from '../../../../../enums/UserProfession';

interface IProps {
  item: IDashboardJob;
  handleOnClick: (item: IDashboardJob) => void;
}

export const renderRow = ({ item, handleOnClick }: IProps) => {
  const {
    office,
    startTime,
    endTime,
    date,
    subProfession,
    professionName,
    specialty,
    rate,
    dashboardJobApi,
  } = item || {};

  return (
    <>
      <TableData text={office.name} />
      <TableData
        text={
          <span>
            <strong>{date}</strong>
            <br />
            {`${startTime} - ${endTime}`}
          </span>
        }
      />
      <TableData
        text={
          <span>
            <strong>{UserSubProfession.getName(subProfession ?? '') ?? professionName}</strong>
            <br />
            {specialty?.split('_')?.[1] ?? 'General'}
          </span>
        }
      />
      <TableData text={`$${rate.toFixed(2)}`} bold />
      <td>
        <InviteProfessional shift={dashboardJobApi} size="icon" />
      </td>
      <RedirectButton onClick={() => handleOnClick(item)} />
    </>
  );
};
